function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _get(target, property, receiver) { if (typeof Reflect !== "undefined" && Reflect.get) { _get = Reflect.get; } else { _get = function _get(target, property, receiver) { var base = _superPropBase(target, property); if (!base) return; var desc = Object.getOwnPropertyDescriptor(base, property); if (desc.get) { return desc.get.call(receiver); } return desc.value; }; } return _get(target, property, receiver || target); }

function _superPropBase(object, property) { while (!Object.prototype.hasOwnProperty.call(object, property)) { object = _getPrototypeOf(object); if (object === null) break; } return object; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

import { Observable } from "observable-fns";

var doNothing = function doNothing() {
  return undefined;
};

var returnInput = function returnInput(input) {
  return input;
};

var runDeferred = function runDeferred(fn) {
  return Promise.resolve().then(fn);
};

function fail(error) {
  throw error;
}

function isThenable(thing) {
  return thing && typeof thing.then === "function";
}
/**
 * Creates a hybrid, combining the APIs of an Observable and a Promise.
 *
 * It is used to proxy async process states when we are initially not sure
 * if that async process will yield values once (-> Promise) or multiple
 * times (-> Observable).
 *
 * Note that the observable promise inherits some of the observable's characteristics:
 * The `init` function will be called *once for every time anyone subscribes to it*.
 *
 * If this is undesired, derive a hot observable from it using `makeHot()` and
 * subscribe to that.
 */


export var ObservablePromise = /*#__PURE__*/function (_Observable) {
  _inherits(ObservablePromise, _Observable);

  var _super = _createSuper(ObservablePromise);

  function ObservablePromise(init) {
    var _this;

    _classCallCheck(this, ObservablePromise);

    _this = _super.call(this, function (originalObserver) {
      // tslint:disable-next-line no-this-assignment
      var self = _assertThisInitialized(_this);

      var observer = Object.assign(Object.assign({}, originalObserver), {
        complete: function complete() {
          originalObserver.complete();
          self.onCompletion();
        },
        error: function error(_error) {
          originalObserver.error(_error);
          self.onError(_error);
        },
        next: function next(value) {
          originalObserver.next(value);
          self.onNext(value);
        }
      });

      try {
        _this.initHasRun = true;
        return init(observer);
      } catch (error) {
        observer.error(error);
      }
    });
    _this.initHasRun = false;
    _this.fulfillmentCallbacks = [];
    _this.rejectionCallbacks = [];
    _this.firstValueSet = false;
    _this.state = "pending";
    return _this;
  }

  _createClass(ObservablePromise, [{
    key: "onNext",
    value: function onNext(value) {
      if (!this.firstValueSet) {
        this.firstValue = value;
        this.firstValueSet = true;
      }
    }
  }, {
    key: "onError",
    value: function onError(error) {
      this.state = "rejected";
      this.rejection = error;

      var _iterator = _createForOfIteratorHelper(this.rejectionCallbacks),
          _step;

      try {
        var _loop = function _loop() {
          var onRejected = _step.value;
          // Promisifying the call to turn errors into unhandled promise rejections
          // instead of them failing sync and cancelling the iteration
          runDeferred(function () {
            return onRejected(error);
          });
        };

        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          _loop();
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
    }
  }, {
    key: "onCompletion",
    value: function onCompletion() {
      var _this2 = this;

      this.state = "fulfilled";

      var _iterator2 = _createForOfIteratorHelper(this.fulfillmentCallbacks),
          _step2;

      try {
        var _loop2 = function _loop2() {
          var onFulfilled = _step2.value;
          // Promisifying the call to turn errors into unhandled promise rejections
          // instead of them failing sync and cancelling the iteration
          runDeferred(function () {
            return onFulfilled(_this2.firstValue);
          });
        };

        for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
          _loop2();
        }
      } catch (err) {
        _iterator2.e(err);
      } finally {
        _iterator2.f();
      }
    }
  }, {
    key: "then",
    value: function then(onFulfilledRaw, onRejectedRaw) {
      var _this3 = this;

      var onFulfilled = onFulfilledRaw || returnInput;
      var onRejected = onRejectedRaw || fail;
      var onRejectedCalled = false;
      return new Promise(function (resolve, reject) {
        var rejectionCallback = function rejectionCallback(error) {
          if (onRejectedCalled) return;
          onRejectedCalled = true;

          try {
            resolve(onRejected(error));
          } catch (anotherError) {
            reject(anotherError);
          }
        };

        var fulfillmentCallback = function fulfillmentCallback(value) {
          try {
            resolve(onFulfilled(value));
          } catch (error) {
            rejectionCallback(error);
          }
        };

        if (!_this3.initHasRun) {
          _this3.subscribe({
            error: rejectionCallback
          });
        }

        if (_this3.state === "fulfilled") {
          return resolve(onFulfilled(_this3.firstValue));
        }

        if (_this3.state === "rejected") {
          onRejectedCalled = true;
          return resolve(onRejected(_this3.rejection));
        }

        _this3.fulfillmentCallbacks.push(fulfillmentCallback);

        _this3.rejectionCallbacks.push(rejectionCallback);
      });
    }
  }, {
    key: "catch",
    value: function _catch(onRejected) {
      return this.then(undefined, onRejected);
    }
  }, {
    key: "finally",
    value: function _finally(onCompleted) {
      var handler = onCompleted || doNothing;
      return this.then(function (value) {
        handler();
        return value;
      }, function () {
        return handler();
      });
    }
  }], [{
    key: "from",
    value: function from(thing) {
      if (isThenable(thing)) {
        return new ObservablePromise(function (observer) {
          var onFulfilled = function onFulfilled(value) {
            observer.next(value);
            observer.complete();
          };

          var onRejected = function onRejected(error) {
            observer.error(error);
          };

          thing.then(onFulfilled, onRejected);
        });
      } else {
        return _get(_getPrototypeOf(ObservablePromise), "from", this).call(this, thing);
      }
    }
  }]);

  return ObservablePromise;
}(Observable);